module.exports = __webpack_public_path__ + "static/frn-wlc-ah-plural.897d5bec.svg";